<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-报名-添加
    -->
    <el-dialog
    title="添加报名"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加报名</div>

      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- 性别下拉框（只能选择男或女） -->
      <el-form-item label="性别" prop="gender">
        <el-select v-model="form.gender" placeholder="请选择性别" class="max-w460">
          <el-option label="男" value="男"></el-option>
          <el-option label="女" value="女"></el-option>
        </el-select>
      </el-form-item>
      
      <!-- 兼职名称选择器（游泳和健身） -->
      <!-- <el-form-item label="兼职名称" prop="jz_menu_id">
        <el-select v-model="form.status" placeholder="请选择兼职名称" class="max-w460">
          <el-option label="游泳" value="swimming"></el-option>
          <el-option label="健身" value="fitness"></el-option>
        </el-select>
      </el-form-item>  -->
      <el-form-item label="兼职名称" prop="coach_coach_id">
        <el-select v-model="form.coach_coach_id" placeholder="请选择兼职名称" class="max-w460">
            <template v-for="jz in jzList">
              <el-option :value="jz.coach_coach_id" :key="jz.coach_coach_id" :label="jz.name"></el-option>
            </template>
        </el-select>
      </el-form-item>
      
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="专业" prop="major">
        <el-input v-model="form.major" placeholder="请输入专业" class="max-w460"></el-input>
      </el-form-item>
        
      <el-form-item label="年级" prop="grade">
        <el-input v-model="form.grade" placeholder="请输入年级" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- 工作周期是否满足六个月（只能选择是或否） -->
      <el-form-item label="工作周期是否满足六个月" prop="cycle">
        <el-select v-model="form.cycle" placeholder="请选择" class="max-w460">
          <el-option label="是" value="是"></el-option>
          <el-option label="否" value="否"></el-option>
        </el-select>
      </el-form-item>
      
      <!-- 代课小时数是否满足20小时（只能选择是或否） -->
      <el-form-item label="代课小时数是否满足20小时" prop="substitute">
        <el-select v-model="form.substitute" placeholder="请选择" class="max-w460">
          <el-option label="是" value="是"></el-option>
          <el-option label="否" value="否"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="资质" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="资质图片"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('album')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="报名介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</el-dialog>
  
</template>

<script>
import Register_registerApi from '@/api/register_register.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        coach_coach_id:'',
       status:[],
        phone: '',
        //  jz_menu_id:'',
        grade:'',
        major: '',
        cycle: '',         // 工作周期是否满足六个月
        substitute: '',    // 代课小时数是否满足20小时
        gender: '',        // 性别
       // jz_menu_id: '',    // 兼职名称
        name: '',          // 姓名
        code: 'custom',
        image: [],         // 资质图片
        sort: 50,
        intro: ""
      },
      loading: false,
       jzList:[],
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        status: [{ required: true, message: '请选择兼职名称', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        major: [{ required: true, message: '请输入专业', trigger: 'blur' }],
        cycle: [{ required: true, message: '请选择工作周期是否满足六个月', trigger: 'change' }],
        substitute: [{ required: true, message: '请选择代课小时数是否满足20小时', trigger: 'change' }],
        sort: [
          { required: true, message: '请输入排序值', trigger: 'blur' },
          { type: 'number', message: '排序必须为数字', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
     this.getJzList()
  },
  props: ["open_add"],
  methods: {
    // getData(){
    //     Register_registerApi.getData().then((res=> {
    //     this.jz_menu_id = res.data.status
    //   }))
    // },
    getJzList(){
      Register_registerApi.getJzList().then(res => {
        this.jzList = res.data.data
      })
    },
    chooseCategory(){
      this.iscategorya = true;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      
      if(form.image.length <= 0) {
        self.$message({
          message: "请上传资质图片",
          type: 'error'
        });
        return;
      }
      
      form.intro = this.$refs.ue.getUEContent();
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Register_registerApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg || '添加成功',
                type: 'success'
              });
              self.dialogFormVisible("success");
            })
            .catch(error => {
              self.loading = false;
              self.$message.error('添加失败，请重试');
            });
        }
      });
    },
    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album') {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      }
      
      this.isProductUpload = false;
    },
    /*删除商品图片*/
    deleteImg(index, code) {
      if(code == 'album') {
        this.form.image.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coach_coach/register/part/add.vue